export default __webpack_public_path__ + "static/media/ERIC-EL-NIÑO.363d8b31.png";